import { useEffect, useState } from "react";

const matches = (query) => {
  try {
    return typeof window !== "undefined" && window.matchMedia(query).matches;
  } catch {
    return false;
  }
};

/** Live boolean for a CSS media query, e.g. "(min-width: 1024px)". */
const useMediaQuery = (query) => {
  const [value, setValue] = useState(() => matches(query));
  useEffect(() => {
    let mql;
    try {
      mql = window.matchMedia(query);
    } catch {
      return undefined;
    }
    const onChange = () => setValue(mql.matches);
    onChange();
    mql.addEventListener?.("change", onChange);
    return () => mql.removeEventListener?.("change", onChange);
  }, [query]);
  return value;
};

export default useMediaQuery;
